import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "owa-link-account", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLinkAccountAndGetAccessToken = new LazyAction(
    lazyModule,
    m => m.linkAccountAndGetAccessToken
);

export const lazyGetAllConnectedAccounts = new LazyAction(
    lazyModule,
    m => m.getAllConnectedAccounts
);

export const lazyGetConnectedAccount = new LazyAction(lazyModule, m => m.getConnectedAccount);

export const lazyAddConnectedAccount = new LazyAction(lazyModule, m => m.addConnectedAccount);

export const lazyRemoveConnectedAccount = new LazyAction(lazyModule, m => m.removeConnectedAccount);

export const lazyRefreshConnectedAccountAccessToken = new LazyAction(
    lazyModule,
    m => m.refreshConnectedAccountAccessToken
);

export const lazyIdpResponseHandler = new LazyAction(lazyModule, m => m.idpResponseHandler);

export const lazySetAddConnectedAccountHandler = new LazyAction(
    lazyModule,
    m => m.setAddConnectedAccountHandler
);

if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    window.Owa.lazyIdpResponseHandler = lazyIdpResponseHandler;
}

// Exported types
export * from './contracts/ConnectedAccountResponse';
export * from './contracts/SharedProperties';
export { AddConnectedAccountHandler } from './types/AddConnectedAccountHandler';
export { ConnectedAccountRequest } from './contracts/ConnectedAccountRequest';
export { ConnectedAccountResponse } from './contracts/ConnectedAccountResponse';
export { ErrorResponse } from './contracts/ErrorResponse';
export { default as UserAccount } from './contracts/UserAccount';
export { getAccessToken } from './utils/getAccessToken';
